import { object, string } from "yup";

export const timedBannerSchema = object({
  banner_text: string().required("Please enter a banner message"),
  expiry_date: string().required("Please select an expiry date"),
});
